import { render, staticRenderFns } from "./EntradasFormList.vue?vue&type=template&id=aceb58d6&"
import script from "./EntradasFormList.vue?vue&type=script&lang=js&"
export * from "./EntradasFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports